<template>
  <div style="padding: 10px 14px">
    <h3>教育课程云隐私政策</h3>
    <p>更新及生效日期：2025年10月1日</p>
    <p>
      <strong>重要提示：请您仔细阅读本协议后再进行登录操作。如您不同意本协议的任何条款，请立即停止登录和使用服务。</strong>
    </p>
    <p>本协议是您与东莞市安道光电材料制造有限公司（以下简称“安道教育”或“我们”）就登录、使用教育课程云（以下简称"本平台"）所订立的协议。</p>
    <p>当您通过账号登录本平台时，即表示您已充分阅读、理解并接受本协议的全部内容，并同意受其约束。</p>
    <p>我们有权修改本协议，修改后的协议将在本平台公布后生效。如您继续使用本平台，即视为接受修改后的协议。</p>

    <strong>
      <p>第一章 个人信息收集</p>
    </strong>
    <p>1.1 在您登录本平台时，我们会收集以下信息：</p>
    <p>（1）账号信息（用户名、加密存储的密码）</p>
    <p>（2）设备信息（设备型号、操作系统版本、唯一设备标识符）</p>
    <p>（3）登录信息（登录时间、IP地址、浏览器类型）</p>
    <p>（4）操作记录（访问页面、使用功能、停留时长）</p>
    <p>1.2 我们通过以下方式收集信息：</p>
    <p>（1）您直接提供的信息</p>
    <p>（2）自动采集的技术信息</p>
    <p>（3）Cookies和类似技术</p>

    <strong>
      <p>第二章 个人信息使用</p>
    </strong>
    <p>2.1 我们使用您的个人信息用于以下目的：</p>
    <p>（1）验证身份并提供登录服务</p>
    <p>（2）维护平台正常运行和安全</p>
    <p>（3）优化服务质量和用户体验</p>
    <p>（4）遵守法律法规要求</p>

    <strong>
      <p>第三章 个人信息共享</p>
    </strong>
    <p>3.1 我们不会将您的个人信息出售给第三方。</p>
    <p>3.2 在以下情况下，我们可能会共享信息：</p>
    <p>（1）获得您明确授权</p>
    <p>（2）应法律法规要求或政府机关指令</p>
    <p>（3）为保护我们或其他用户的合法权益</p>

    <strong>
      <p>第四章 个人信息保护</p>
    </strong>
    <p>4.1 我们采取严格的安全措施保护您的信息，包括：</p>
    <p>（1）数据加密传输和存储</p>
    <p>（2）访问权限控制</p>
    <p>（3）安全审计机制</p>
    <p>4.2 我们仅会在实现本政策所述目的所需的期限内保留您的信息。</p>

    <strong>
      <p>第五章 您的权利</p>
    </strong>
    <p>5.1 您享有以下权利：</p>
    <p>（1）查询、更正您的个人信息</p>
    <p>（2）删除您的个人信息</p>
    <p>（3）撤回已同意的授权</p>
    <p>（4）获取个人信息副本</p>
    <p>5.2 您可以通过以下方式行使权利：</p>
    <p>（1）登录平台账号设置</p>
    <p>（2） 联系客服人员</p>

    <strong>
      <p>第六章 Cookies使用</p>
    </strong>
    <p>6.1 我们使用Cookies来：</p>
    <p>（1）维持登录状态</p>
    <p>（2）记住您的偏好设置</p>
    <p>（3）分析服务使用情况</p>
    <p>6.2 您可以通过浏览器设置管理Cookies，但可能会影响某些功能的使用。</p>

    <strong>
      <p>第七章 政策更新</p>
    </strong>
    <p>7.1 我们可能会适时修订本政策，并通过平台公告等方式通知您。</p>
    <p>7.2 若您继续使用我们的服务，即表示同意修订后的政策。</p>

    <p>
      <strong>第八章 联系我们</strong>
    </p>

    <P>如果您对本协议有任何疑问，请联系：</P>
    <P>公司：{{ activationCompany.company }}</P>
    <P>电话：400-632-8880</P>
    <P>联系人：客服专员</P>
    <P>地址：{{ activationCompany.address }}</P>
    <p>
      <strong>再次提醒：登录操作即代表您已阅读、理解并同意接受本协议所有条款的约束。</strong>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
}
</style>
